import $ from 'jquery';
import debounce from '../../utils/debounce';

const calcHeaderSize = () => {
	const el = {
		header: '.elementor.elementor-location-header',
	};

	const init = () => {
		$(function () {
			if (!$(el.header).length) return;

			exec();

			$(window).on(
				'resize',
				debounce(function () {
					exec();
				}),
			);
		});
	};

	const exec = () => {
		const headerHeight = $(el.header).outerHeight();

		$('body').css('--header-height', `${headerHeight}px`);
	};

	init();
};

try {
	calcHeaderSize();
} catch (error) {
	console.error(error);
}
